import { GraphQL } from '@guestgoodie/graphql'

export function isNewFile(file: unknown): file is NewFile {
  return (
    !!file &&
    typeof file === 'object' &&
    'file' in file &&
    file.file instanceof File
  )
}

export function isDirtyFile(file: GoodieFile): file is DirtyFile {
  return !isNewFile(file) && 'isDirty' in file && file.isDirty
}

export function isGraphqlFile(
  file: GoodieFile
): file is GraphQL.FileFragmentFragment {
  return 'state' in file
}

export interface NewFile {
  captions?: GraphQL.Caption[] | null
  processingMetadata?: GraphQL.ProcessingMetadata
  alwaysMute?: boolean
  altText?: string
  file: File
  translations?: GraphQL.TranslationInput[]
}

export type DirtyFile = Omit<GraphQL.FileFragmentFragment, 'translations'> & {
  isDirty: true
  translations?: (GraphQL.TranslationInput | GraphQL.Translation)[]
}

export type GoodieFile = NewFile | GraphQL.FileFragmentFragment | DirtyFile
export type ExistingFile = GraphQL.FileFragmentFragment | DirtyFile

export enum DropPositions {
  left = 'LEFT',
  right = 'RIGHT'
}
